import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useEffect } from 'react';
import { themed } from '@indeed/ifl-css';
import { useDialogContext } from './context.js';
import { jsx } from '@emotion/react';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';

const baseStyles = _ref => {
  let {
    dialogBodyScrollPosition,
    isDialogBodyVisible,
    type
  } = _ref;
  return {
    alignItems: "center",
    borderBlockStartWidth: type === "popup" || !isDialogBodyVisible || !dialogBodyScrollPosition || dialogBodyScrollPosition === "bottom" ? 0 : "1px",
    borderBlockStartStyle: "solid",
    borderColor: "border.weak",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    inlineSize: "100%",
    justifyContent: "flex-end",
    paddingBlockEnd: ["3", "4"],
    paddingBlockStart: !isDialogBodyVisible ? 0 : ["3", "4"],
    paddingInlineEnd: type === "popup" ? 4 : ["3", "4"],
    paddingInlineStart: ["3", "4"],
    position: "relative",
    "@media screen and (max-height: 32rem)": {
      // Small screen resolutions don't need a border on the top of the footer
      borderBlockStartWidth: 0
    }
  };
};
const styleProps = new Set(["dialogBodyScrollPosition", "isDialogBodyVisible", "type"]);
const StyledDialogFooter = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "ekmvxbp0"
} : {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "ekmvxbp0",
  label: "StyledDialogFooter"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const DialogFooter = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    ...remainingProps
  } = _ref2;
  const {
    dialogBodyScrollPosition,
    isDialogBodyVisible,
    setDialogFooterVisibility,
    type
  } = useDialogContext();

  // Set component visibility
  useEffect(() => {
    setDialogFooterVisibility(true);
  }, [setDialogFooterVisibility]);
  return jsx(StyledDialogFooter, _extends({
    dialogBodyScrollPosition: dialogBodyScrollPosition,
    isDialogBodyVisible: isDialogBodyVisible,
    ref: forwardedRef,
    type: type
  }, remainingProps), children);
});
DialogFooter.displayName = "DialogFooter";

export { DialogFooter, baseStyles };
